import {
    getData,
} from './Services'

export const getSucursalesInfo = async () => {
    const res = await getData('/sucursales'); 
    return res
}

